import { reduxKey } from './constants';
export function getArtAuthor(state) {
    return state[reduxKey].artAuthor;
}

//# sourceMappingURL=selectors.js.map